require('../../app.js')

Vue.component('tabs', require('../../components/Tabs.vue').default)
Vue.component('tab', require('../../components/Tab.vue').default)
